<main class="overflow-x-hidden px-4 pt-8 md:pt-24">

  <div class="mx-auto max-w-6xl mb-16">

    <picture>
      <source [srcset]="assetsPath + 'uci-cyclisme-sur-piste.webp'" type="image/webp">
      <source [srcset]="assetsPath + 'uci-cyclisme-sur-piste.png'" type="image/png">
      <img class="w-36 sm:w-48 mb-3" [src]="assetsPath + 'uci-cyclisme-sur-piste.png'"
        alt="Championnats du monde de cyclisme sur piste" />
    </picture>
    <h1 class="text-3xl sm:text-5xl/tight" i18n>L'expertise de Quick-Off dans la gestion bénévoles des Championnats du Monde
      de Cyclisme sur Piste</h1>
  </div>

  <picture>
    <source [srcset]="assetsPath + 'benevoles-championnats-du-monde-cyclisme-sur-piste.webp'" type="image/webp">
    <source [srcset]="assetsPath + 'benevoles-championnats-du-monde-cyclisme-sur-piste.jpg'" type="image/jpg">
    <img class="mx-auto max-w-7xl w-full rounded-2xl sm:rounded-6xl mb-16" [src]="assetsPath + 'benevoles-championnats-du-monde-cyclisme-sur-piste.jpg'"
      alt="Bénévoles championnats du monde de cyclisme sur piste" loading="lazy" />
  </picture>

  <div class="flex flex-col md:flex-row gap-6 max-w-6xl mx-auto mb-16">
    <div class="flex-1 px-4 md:px-0 md:py-3 text-center">
      <p class="mb-4 text-6xl font-bold" i18n>338</p>
      <p i18n>candidatures</p>
    </div>
    <div class="h-2 w-4/5 self-center md:h-auto md:w-2 md:self-stretch bg-[#6DC94C] rounded"></div>
    <div class="flex-1 px-4 md:px-0 md:py-3 text-center">
      <p class="mb-4 text-6xl font-bold" i18n>5</p>
      <p i18n>jours de compétition</p>
    </div>
    <div class="h-2 w-4/5 self-center md:h-auto md:w-2 md:self-stretch bg-[#6DC94C] rounded"></div>
    <div class="flex-1 px-4 md:px-0 md:py-3 text-center">
      <p class="mb-4 text-6xl font-bold" i18n>2</p>
      <p i18n>chefs de projet Quick-Off<br />présents sur place</p>
    </div>
  </div>

  <p class="mx-auto max-w-3xl mb-8" i18n>
    Pour la deuxième année consécutive, Arnaud et Hugo, nos chefs de projet événementiel chez Quick-Off, ont été chargés
    de piloter le programme bénévole des championnats du monde de cyclisme sur piste. En 2021 à Roubaix, puis en 2022 au
    Vélodrome de Saint-Quentin-en-Yvelines, nos coordinateurs ont orchestré une gestion sans faille de l'équipe
    bénévoles, démontrant l'expertise de Quick-Off dans la coordination d'équipes pour des compétitions internationales
    d'envergure.
  </p>

  <p class="mx-auto max-w-3xl mb-16" i18n>
    L'intégralité du processus de <strong>gestion bénévole</strong> a été facilitée par notre solution Qoezion,
    développée pour répondre
    spécifiquement à ces défis. Notre <strong>expertise technique avec Qoezion</strong> et l'<strong>expérience sur le
      terrain</strong> de nos équipes se
    sont combinées pour créer une harmonie dans la gestion des bénévoles, garantissant ainsi le succès de l'événement et
    une expérience inoubliable pour tous les participants.
  </p>

  <qo-customer-story [story]="customerStory" theme="qomeet"></qo-customer-story>

  <div class="flex mx-auto items-center max-w-7xl gap-4 sm:gap-12 md:gap-24 mb-16">
    <picture>
      <source [srcset]="assetsPath + 'benevoles-missions-competitions-internationale-cyclisme.webp'" type="image/webp">
      <source [srcset]="assetsPath + 'benevoles-missions-competitions-internationale-cyclisme.jpg'" type="image/jpg">
      <img class="rounded-2xl sm:rounded-6xl" [src]="assetsPath + 'benevoles-missions-competitions-internationale-cyclisme.jpg'" alt="Installation des équipements"
        loading="lazy" />
    </picture>
    <picture>
      <source [srcset]="assetsPath + 'benevoles-controle-acces-accreditation.webp'" type="image/webp">
      <source [srcset]="assetsPath + 'benevoles-controle-acces-accreditation.jpg'" type="image/jpg">
      <img class="rounded-2xl sm:rounded-6xl" [src]="assetsPath + 'benevoles-controle-acces-accreditation.jpg'" alt="Accueil des bénévoles"
        loading="lazy" />
    </picture>
  </div>

  <h3 class="text-2xl mx-auto max-w-3xl mb-8" i18n>Optimisez votre gestion événementielle d'édition en édition avec un
    logiciel performant</h3>

  <p class="mx-auto max-w-3xl mb-8" i18n>
    Découvrez comment la <a class="font-bold underline" [routerLink]="NavigationService.Routes.Qoezion()">solution
      logicielle Qoezion</a> vous permet de gagner du temps et de capitaliser sur les éditions futures :
  </p>

  <p class="mx-auto max-w-3xl" i18n><strong>- Dupliquez vos événements en un clin d'œil</strong> : Choisissez les éléments
    que vous souhaitez conserver, tels que le formulaire de candidature, les activités, les créneaux horaires, les
    effectifs, et plus encore.</p>
  <p class="mx-auto max-w-3xl" i18n><strong>- Développez et fidélisez votre communauté de bénévoles</strong> : Constituez une
    communauté au fil de vos différents événements, favorisant ainsi un engagement continu et une expérience
    enrichissante pour les participants.</p>
  <p class="mx-auto max-w-3xl mb-8" i18n><strong>- Facilitez l'inscription des bénévoles</strong> : Simplifiez l'inscription
    des bénévoles dès leur première participation en offrant une expérience fluide et intuitive.</p>

  <p class="mx-auto max-w-3xl mb-16" i18n>
    Ainsi, l'organisation de chaque nouvelle édition devient plus efficace et mieux structurée. La fonctionnalité de
    duplication d'événement offerte par Qoezion a grandement simplifié la préparation de la deuxième édition, illustrant
    parfaitement son efficacité. La possibilité de mobiliser une communauté déjà inscrite lors de l'année précédente
    témoigne de la <strong>fidélisation des bénévoles</strong> d'une édition à l'autre, ainsi que de leur compréhension
    des missions de
    l'événement.
  </p>

  <h2 class="mb-12 text-center text-3xl md:text-5xl/tight font-title  px-4 max-w-5xl mx-auto" i18n>Un mot du chef de projet
    Quick-Off</h2>

  <qo-customer-story [story]="qoCustomerStory" theme="qomeet"></qo-customer-story>

  <div class="flex mx-auto items-center justify-center max-w-7xl gap-4 sm:gap-12 md:gap-24 mb-24">
    <picture>
      <source [srcset]="assetsPath + 'chefs-projets-evenementiel-competition-internationale-cyclisme.webp'" type="image/webp">
      <source [srcset]="assetsPath + 'chefs-projets-evenementiel-competition-internationale-cyclisme.jpg'" type="image/jpg">
      <img class="rounded-2xl sm:rounded-6xl" [src]="assetsPath + 'chefs-projets-evenementiel-competition-internationale-cyclisme.jpg'" alt="Chefs de projet Quick-Off"
        loading="lazy" />
    </picture>
    <picture>
      <source [srcset]="assetsPath + 'benevoles-championnats-cyclisme-sur-piste.webp'" type="image/webp">
      <source [srcset]="assetsPath + 'benevoles-championnats-cyclisme-sur-piste.jpg'" type="image/jpg">
      <img class="rounded-2xl sm:rounded-6xl" [src]="assetsPath + 'benevoles-championnats-cyclisme-sur-piste.jpg'" alt="Bénévoles"
        loading="lazy" />
    </picture>
  </div>

  <h2 class="mb-12 text-center text-3xl md:text-5xl/tight font-title  px-4 max-w-5xl mx-auto" i18n>Et maintenant, pourquoi pas
    vous ?</h2>

  <div class="mb-16">
    <qo-try-and-book></qo-try-and-book>
  </div>

  <div class="mb-8">
    <qo-poster-list [multiline]="true"></qo-poster-list>
  </div>


</main>
